<div class="feedback-button-wrapper" ngbTooltip="Give us your feedback" *ngIf="survey">
    <a class="svg-hover-dropshadow" (click)="openFeedbackForm()">
        <pureui-svg svg="feedback.svg" width="46"></pureui-svg>
    </a>
</div>
